export default __webpack_public_path__ + "static/media/TR.da8b9abd.ico";